import script from "./Recaptcha.vue?vue&type=script&lang=ts&setup=true"
export * from "./Recaptcha.vue?vue&type=script&lang=ts&setup=true"

import "./Recaptcha.vue?vue&type=style&index=0&id=45b3e872&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-45b3e872"]])

export default __exports__